export const REACT_GA_USER_CATEGORY               = 'User';
export const REACT_GA_USER_LOGIN_MESSAGE_TEMPLATE = 'A user logged in with userId= ';



// WEBPACK FOOTER //
// ./src/common/googleAnalyticsConstants.js